import { render, staticRenderFns } from "./HorseSkillHistoryTable.vue?vue&type=template&id=35f1951f&scoped=true&"
import script from "./HorseSkillHistoryTable.vue?vue&type=script&lang=js&"
export * from "./HorseSkillHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./HorseSkillHistoryTable.vue?vue&type=style&index=0&id=35f1951f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1951f",
  null
  
)

export default component.exports